import { KindRootNodeStoreProvider } from '../Store'

import { KindRootNodeCheckboxCore } from './Core'
import { KindRootNodeCheckboxProps } from './interface'

export const KindRootNodeCheckbox = <M extends boolean>({
  /* -------------------------------------------------------------------------- */
  /*                       KindRootNodeCheckboxCore Props                       */
  /* -------------------------------------------------------------------------- */
  disabled,
  /* -------------------------------------------------------------------------- */
  /*                       KindRootNodeStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  ...providerProps
}: KindRootNodeCheckboxProps<M>) => {
  return (
    <KindRootNodeStoreProvider {...providerProps}>
      <KindRootNodeCheckboxCore disabled={disabled} />
    </KindRootNodeStoreProvider>
  )
}
